/* eslint-disable @typescript-eslint/no-useless-constructor */
/* eslint-disable @typescript-eslint/no-empty-interface */
import React from "react";
import { RouteComponentProps } from "@reach/router";
import { MDBRow, MDBCol, MDBBtn } from "mdbreact";
import { Formik, Form } from "formik";
import { Link, navigate } from "gatsby";

// Components
import SEO from "../../../components/Base/SEO";
import BasePureComponet from "../../../components/Base/BasePureComponet";

//Images & Icons
import Logo from "./../../../assets/images/Logo.svg";
import Illustration_Doctor from "./../../../assets/images/Illustration_Doctor.svg";

// Style
import { InputText, InputPassword } from "../../../components/Custom/Input";
import "./Signup.scss";

interface SignupProps extends RouteComponentProps {
  title: string;
}

interface SignupState {}

class Signup extends BasePureComponet<SignupProps> {
  constructor(props: SignupProps) {
    super(props);
  }

  signUpForm = {
    userName: "",
    password: "",
    passwordConfirm: "",
  };

  Register = () => {
    navigate("/home");
  };

  render() {
    return (
      <>
        <SEO title={this.props.title} />
        <MDBRow className="signup m-auto" justify={"center"} align="middle">
          <MDBCol className="my-auto ml-4" md={"4"} sm={"8"}>
            <img className="w-100" src={Illustration_Doctor} alt="" />
          </MDBCol>

          <MDBCol className="my-auto p-lg-5 p-md-3" md={"4"} sm={"8"}>
            <MDBRow>
              <MDBCol className="d-flex justify-content-center">
                <h2 className="title">مرحبا بك في</h2>
                <img className="logo" src={Logo} alt="Logo" />
              </MDBCol>
            </MDBRow>

            <MDBRow>
              <MDBCol order={1}>
                <p className="description">
                  نجعل الحياة الطبية والاجتماعية سهلة للجميع.
                </p>
              </MDBCol>
            </MDBRow>

            <MDBRow>
              <Formik
                initialValues={this.signUpForm}
                onSubmit={() => {}}
                render={formProp => (
                  <Form>
                    <InputText
                      name={"userName"}
                      placeholder="البريد الالكتروني او رقم الهاتف"
                    />

                    <InputPassword
                      className="my-3"
                      name={"password"}
                      placeholder="كلمة المرور"
                    />

                    <InputPassword
                      className="my-3"
                      name={"passwordConfirm"}
                      placeholder="أعد كتابة كلمة المرور"
                    />

                    <p>
                      بالنقر فوق إنشاء حساب فإنك توافق على قبول{" "}
                      <a href="#">الأحكام والشروط</a>
                    </p>

                    <MDBBtn
                      color="primary"
                      type={"button"}
                      onClick={this.Register}
                    >
                      إنشاء الحساب
                    </MDBBtn>
                  </Form>
                )}
              />

              <p className="link-after-form mt-3">
                هل لديك حساب ؟<Link to={"/signin"}>تسجيل الدخول</Link>
              </p>
            </MDBRow>
          </MDBCol>
        </MDBRow>
      </>
    );
  }
}

export default Signup;
